import styled from 'styled-components'

export const NavigationSliderWrapper = styled.div`
  & input {
    color: #000 !important;
  }
`

export const Row = styled.tr.attrs<{
  isSelected?: boolean
}>((props) => ({
  'data-is-selected': props.isSelected || null
}))<{ isSelected?: boolean; isHighlighted?: boolean }>`
  position: relative;
  --cell-bgcolor: transparent !important;

  button[disabled] {
    background-color: transparent !important;
  }

  td {
    ${({ isSelected, isHighlighted }) =>
      (isSelected || isHighlighted) &&
      `
      &:first-child {
        border-radius: 4px 0 0 4px;
      }

      &:last-child {
        border-radius: 0 4px 4px 0;
      }
  `}
  }

  &.active {
    td {
      background-color: #c7deff;
    }
  }

  &:not(.active):nth-of-type(even) {
    td {
      background-color: #f7f8fa;
    }
  }

  ${({ isHighlighted }) =>
    isHighlighted &&
    `
      &&& td {
        background-color: #FFDE69;
      }
  `}

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 2px solid transparent;
    border-radius: 4px;
    pointer-events: none;
    ${({ isSelected }) =>
      isSelected &&
      `
    border-color: #ABBED1;
  `}
  }
`
